import { useState } from 'react';

export interface ModalState {
  isLogModalOpen: boolean;
  isReminderModalOpen: boolean;
  isEditProfileModalOpen: boolean;
  isPetSelectorOpen: boolean;
  isEditUserModalOpen: boolean;
  isUpgradeModalOpen: boolean;
}

export interface ModalActions {
  setIsLogModalOpen: (open: boolean) => void;
  setIsReminderModalOpen: (open: boolean) => void;
  setIsEditProfileModalOpen: (open: boolean) => void;
  setIsPetSelectorOpen: (open: boolean) => void;
  setIsEditUserModalOpen: (open: boolean) => void;
  setIsUpgradeModalOpen: (open: boolean) => void;
}

export const useModalState = (): ModalState & ModalActions => {
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);
  const [isPetSelectorOpen, setIsPetSelectorOpen] = useState(false);
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  return {
    // State
    isLogModalOpen,
    isReminderModalOpen,
    isEditProfileModalOpen,
    isPetSelectorOpen,
    isEditUserModalOpen,
    isUpgradeModalOpen,
    
    // Actions
    setIsLogModalOpen,
    setIsReminderModalOpen,
    setIsEditProfileModalOpen,
    setIsPetSelectorOpen,
    setIsEditUserModalOpen,
    setIsUpgradeModalOpen,
  };
};
